import { apiClient } from "api";
import { TUnreadMessageCount, TWebDMessage } from "./models/message.types";

export const getWebMessages = async (view: string) => {
  const response = await apiClient.get(`messages/${view.toLocaleLowerCase()}`);
  return response.data;
};

export const getInboxMessages = async () => {
  const response = await apiClient.get(`messages/inbox`);
  return response.data;
};

export const getSentMessages = async () => {
  const response = await apiClient.get(`messages/sent`);
  return response.data;
};

export const markMessageAsRead = (messageId: number) => {
  return apiClient.put(`messages/markAsRead/${messageId}`);
};

export const sendMessage = async (message: TWebDMessage): Promise<TWebDMessage[]> => {
  const response = await apiClient.post("messages", message);
  return response.data;
};

export const getUnread = async (): Promise<TUnreadMessageCount> => {
  const response = await apiClient.get("messages/unread");
  return response.data;
};
